import React from "react";
import { NumberInput, SaveButton, SimpleForm, TextInput, Toolbar } from "react-admin";

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const LevelForm = (props) => (
  <SimpleForm {...props} toolbar={<CustomToolbar />}>
    <TextInput label="Nome" source="name" />
    <NumberInput source={"rank"} label={"Rank"} />
  </SimpleForm>
);
